import { h } from '../pragma.mjs';

export default () => {

    return (
        <div>

            <gov-breadcrumbs wcag-label="Úroveň zanoření v rozcestníku">
                <ul class="breadcrumbs">
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikRoot" href="#">Domů</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikZapisy" href="#">Zápisy</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><strong>Změna údajů o pozemcích</strong></li>
                </ul>
            </gov-breadcrumbs>
            
            <gov-tiles>
                <gov-tile id="rozcestnikZmenitS8414" href="#">
                    <p>Změna druhu a způsobu využití pozemku, včetně rozdělení a sloučení pozemků, zpřesnění hranic a zápisu údajů o stavbě, která je součástí pozemku</p>
                    <h3 slot="title">Změna druhu a způsobu využití pozemku</h3>
                    <gov-icon type="complex" name="my-filing" slot="icon"></gov-icon>
                </gov-tile>
                {/* <gov-tile class="gray_card" id="toastHranice" href="#">
                    <h3 slot="title">Změna katastrální hranice</h3>
                    <gov-icon type="complex" name="region" slot="icon"></gov-icon>
                </gov-tile> */}
            </gov-tiles>
        </div>
    )

}